import {modalDefaults} from './Modal_defaults';
import utilities from './utilities/utilities';
import { parseInt, find } from 'lodash-es';

export default class MegaModal {

	/**
	 * This is an extension of the Modals, separated this out to be the parent of Modals
	 * as all functions below need to be inherited by a modal construction.
	 * These functions will keep track of the position, size, close etc
	 */
	constructor () {
		document.addEventListener('keydown', this.escClose);
	}

	/**
	 * Adds the modal overlay if it does no already exist
	 */
	overLay () {
		if (modalDefaults.overlay === null) {
			this.overlay = document.createElement('div');
			this.overlay.setAttribute('id', 'mega-modal-overlay');

			document.body.appendChild(this.overlay);
			modalDefaults.overlay = this.overlay;
		} else {
			this.overlay = modalDefaults.overlay;
		}
	}

	/**
	 * Generates an SVG
	 * @param id
	 * @returns SVG
	 */
	generateSVG (id) {
		let svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
		let use = document.createElementNS('http://www.w3.org/2000/svg', 'use');
		use.setAttributeNS('http://www.w3.org/1999/xlink', 'href', id);
		use.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', id);
		use.setAttribute('class', 'close-icon');
		svg.appendChild(use);

		return svg;
	}

	/**
	 * Closes all modals current open
	 * @param event
	 */
	closeAll (event) {
		if (event) {
			event.preventDefault();
		}

		modalDefaults.id = 0;
		modalDefaults.overlay = null;

		let modals = document.querySelectorAll('[mega-modal-id]');

		for (let i = 0; i < modals.length; ++i) {
			modals[i].parentNode.removeChild(modals[i]);
		}

		document.body.classList.remove('mega-modal-open');
		window.removeEventListener('resize', this.resizeElements);
	}

	/**
	 * Closes the top layer model and brings the one behind (if any) to the front
	 * @param event
	 */
	escClose (event){
		let evt = event || window.event;

		if (evt.keyCode === 27 &&
			modalDefaults.modals[modalDefaults.id] &&
			modalDefaults.modals[modalDefaults.id].options.headerCloseButton
		) {
			modalDefaults.modals[modalDefaults.id].close();
		}
	}

	/**
	 * Resizes the modals if any changes are detected on the DOM
	 */
	resizeElements () {
		let modalList = document.querySelectorAll('[mega-modal-id]');

		let modals = [].slice.call(modalList, 0).reverse();
		let lastElement = null;
		let adjustPosition = {
			top: 0,
			left: 10,
			height: 0,
			width: 20,
		};

		for (let i = 0; i < modals.length; ++i) {
			this.positionElements(modals[i], lastElement, adjustPosition);
			lastElement = modals[i];
			adjustPosition.top += 30;

			if (i === 0) {
				modals[i].classList.add('current-modal');
				modals[i].classList.remove('previous-modal');
			} else {
				modals[i].classList.add('previous-modal');
				modals[i].classList.remove('current-modal');
			}
		}

		if (modalDefaults.overlay) {
			modalDefaults.overlay.lastChild.style.marginBottom = '120px';
		}
	}

	/**
	 * Gets the overlay size
	 * @returns {{width: number, height: number}}
	 * @private
	 */
	getOverlaySize () {
		return {
			width: this.overlay.width || document.body.clientWidth,
			height: this.overlay.height || document.body.clientHeight,
		};
	}

	/**
	 *
	 * @param id
	 */
	findModalPositionByID (id) {
		return find(modalDefaults.modalPosition, (x) => x.id === id);
	}

	/**
	 * Positions modals based on they're current element condition
	 * (bring to the front, send the back, re-position in the center etc)
	 * @param element
	 * @param lastElement
	 * @param position
	 */
	positionElements (element, lastElement, position) {
		let windowSize = this.getOverlaySize();
		let currentId = parseInt(element.getAttribute('mega-modal-id'), 10);
		let result = this.findModalPositionByID(currentId);
		let elementSize;

		element.style.height = '0px';

		if (element.style.display !== 'none') {
			elementSize = utilities.getElementSize(element);
			let top, left, width, height;

			if (!lastElement) {
				top = '150px';
				left = `${Math.round((windowSize.width - elementSize.width) / 2)}px`;
				element.style.top = top;
				element.style.left = left;
				element.style.height = `${elementSize.height}px`;
			}

			if (lastElement) {
				let lastElementPosition = lastElement.getBoundingClientRect();
				let header = utilities.getElementSize(element.querySelector('.modal-header'));
				let start;
				top = `${Math.round((lastElementPosition.top) - position.top)}px`;
				left = `${Math.round((lastElementPosition.left) + position.left)}px`;
				width = `${Math.round((lastElementPosition.width) - position.width)}px`;
				height = `${(header.height + 50)}px`;

				start = Math.round((lastElementPosition.top));
				element.style.top = start;

				let increment = 0;
				let test = position.top;

				let timer = setInterval(() => {
					increment += 5;

					element.style.transform = `translate3d(0, -${increment}px, -${increment}px)`;

					if (increment >= test) {
						clearInterval(timer);
					}
				}, 0);

				element.style.left = left;
				element.style.width = width;
				element.style.height = height;
			}

			if (!result){
				modalDefaults.modalPosition.push({
					id: currentId,
					width: `${elementSize.width}px`,
					height: `${elementSize.height}px`,
					top,
					left,
				});
			}
		}
	}

	/**
	 * Resize a previous modal
	 * @param val
	 */
	resizePrevious (val) {
		let target = 'mega-modal-id';
		let result = this.findModalPositionByID(parseInt(val, 10));
		let modals = document.querySelectorAll(`[${target}]`);

		for (let i = 0; i < modals.length; ++i) {
			modals[i].style.transform = '';
		}

		let previousModal = document.querySelector(`[${target}="${val}"]`);

		previousModal.style.top = result.top;
		previousModal.style.left = result.left;
		previousModal.style.width = result.width;

		if (previousModal.querySelector('.mega-modal-form') !== null){
			previousModal.style.height = '';
		} else {
			previousModal.style.height = result.height;
		}
	}

	/**
	 * Destroys the overlay if no more modals are open
	 */
	destroyOverlay () {
		if (this.overlay !== null) {
			this.overlay.parentNode.removeChild(this.overlay);
			this.overlay = null;
			modalDefaults.overlay = null;
		}
	}

	/**
	 * Locks the body so you cannot window scroll behind the modal when you have one open
	 */
	lockBody () {
		if (modalDefaults.id <= 0) {
			this.destroyOverlay();
		}
	}

	/**
	 * Resize modal container
	 */
	resizeContainer () {
		let modalID = this.id;

		if (modalDefaults.modalPosition[modalID]) {
			let elementPos = utilities.getElementSize(this.modal);
			modalDefaults.modalPosition[modalID].height = `${elementPos.height}px`;
			modalDefaults.modalPosition[modalID].width = `${elementPos.width}px`;
		}
	}

}
